export default __webpack_public_path__ + "static/media/AddressingChronicThroatClearing.4eb87e4d.pdf";